import React from "react";

const SegTitle = ({
    title
}) => {
  return (
    <div className="w-full flex justify-center items-center bg-blue-600 py-2">
      <h2 className="text-white text-medium font-semibold">{title}</h2>
    </div>
  );
};

export default SegTitle;
